import { Device } from '@helpers/media';
export const FilterBreakpoint = Device.TabletLarge;
const FilterStyles = {};
export default FilterStyles;
